import { CLEANING_AREA_TYPES, CLEANING_PERIODICITY_TYPES } from '@spa/shared/constants/cleaningServices';
import { depositDisplayType } from '@spa/shared/constants/depositDisplay';
import { depositType } from '@spa/shared/constants/depositType';
import { getOtherFeeTranslationKey } from '@spa/shared/constants/otherFees';
import { PAY_TO } from '@spa/shared/constants/payTo';
import { formatMoney } from '@spa/shared/utils';
import { capitalizeFirstLetter } from '@spa/shared/utils/stringManipulation';
import { kebabToTitleCase } from '@spa/shared/utils/strings';

const { NONE, UNKNOWN } = CLEANING_PERIODICITY_TYPES;
const { COMMON, FULL } = CLEANING_AREA_TYPES;

const CLEANING_AREAS_TEXT_MAP = {
  [COMMON]: 'of the common areas',
  [FULL]: 'of all house sections'
};

export const getDepositInfo = (contract, t) => {
  const { pay_to: payTo, type, value } = contract?.deposit || {};
  const displayType = payTo === PAY_TO.US ? depositDisplayType.HOLDING : depositDisplayType.SECURITY;

  if (type !== depositType.FIXED) {
    return {
      type: displayType,
      amount: t('Equal to first rent')
    };
  }

  if (type === depositType.FIXED && value?.amount > 0) {
    return {
      type: displayType,
      amount: formatMoney(value?.amount, value?.currency_code)
    };
  }

  return null;
};

export const assembleFeeTitle = feeType => getOtherFeeTranslationKey(feeType) ?? kebabToTitleCase(feeType);

export const assembleCleaningFeeBaseDescription = (cleaning, formattedRecurrenceOfFee, t) => {
  const cleaningArea = cleaning?.type;
  const cleaningFrequency = cleaning?.periodicity;
  if (!cleaning || (!cleaningArea && !cleaningFrequency)) {
    return null;
  }

  const isFrequencySpecified = cleaningFrequency && ![NONE, UNKNOWN].includes(cleaningFrequency);
  const isAreaSpecified = !!CLEANING_AREAS_TEXT_MAP[cleaningArea];
  if (!isFrequencySpecified && !isAreaSpecified) {
    return null;
  }

  const cleaningFrequencyText = isFrequencySpecified ? `${cleaningFrequency} cleaning` : 'cleaning';
  const cleaningAreaText = CLEANING_AREAS_TEXT_MAP[cleaningArea] ?? 'provided';

  if (formattedRecurrenceOfFee) {
    return t('{{recurrence}} charged for the {{frequency}} {{area}}', {
      recurrence: formattedRecurrenceOfFee,
      frequency: t(cleaningFrequencyText),
      area: t(cleaningAreaText)
    })
      .trimStart()
      .trimEnd();
  }

  return `${capitalizeFirstLetter(t(cleaningFrequencyText))} ${t(cleaningAreaText)}`;
};

export const formatRecurrenceOfFee = recurrence => (recurrence ? `${kebabToTitleCase(recurrence)} fee` : '');
